import React from "react";
import apPoliceLogo from "../Images/Partners/ApPolice-logo.png";
import logo2 from "../Images/Partners/bharat-biotech-logo.jpg";
import logo3 from "../Images/Partners/Bhavini-logo.png";
import bobLogo from "../Images/Partners/Bank-of-Baroda-blogo.png";
import drdoLogo from "../Images/Partners/drdo-seeklogo.png";
import logo6 from "../Images/Partners/ICRISAT-logo.png";
import logo7 from "../Images/Partners/iaf_logo.png";
import logo8 from "../Images/Partners/IndianNavy.png";
import IOBLogo from "../Images/Partners/IOBlogo.png";
import logo10 from "../Images/Partners/NFC.png";
import logo12 from "../Images/Partners/TGMDC-logo (1).jpg";
import CanaraLogo from "../Images/Partners/canara-bank-seeklogo.png";
import TelLogo from "../Images/Partners/logo-new (1).png";

const logos = [
  apPoliceLogo,
  logo2,
  logo3,
  bobLogo,
  drdoLogo,
  logo6,
  logo7,
  logo8,
  IOBLogo,
  logo10,
  TelLogo,
  logo12,
  CanaraLogo,
];
const ClientsView = () => {
  return (
    <div className="overflow-hidden flex justify-center items-center gap-10 flex-col relative ">
      <h2 className="text-3xl font-bold text-white  text-center ">
        Our Clients
      </h2>
      <div className="relative flex justify-center p-5">
        <div className="flex flex-wrap gap-12 justify-center items-center ">
          {logos.map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Client Logo ${index + 1}`}
              className="object-contain w-72 h-44 shadow-md rounded p-2 border border-lightGray bg-white cursor-pointer transition-transform duration-500 hover:scale-110"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientsView;
